import { render, staticRenderFns } from "./kamiInfo.vue?vue&type=template&id=6e7fd8ca&scoped=true"
import script from "./kamiInfo.vue?vue&type=script&lang=js"
export * from "./kamiInfo.vue?vue&type=script&lang=js"
import style0 from "./kamiInfo.vue?vue&type=style&index=0&id=6e7fd8ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7fd8ca",
  null
  
)

export default component.exports